import { apiClient } from '@/lib/apiClient';

import type { Hpg, HpgCreate, HpgUpdate } from './types';

const base = (uidProtocolo: string) => `/protocolos/${uidProtocolo}/analisis-hpg`;

export const hpgApi = {
  async create(uidProtocolo: string, data: HpgCreate, signal?: AbortSignal): Promise<Hpg> {
    const response = await apiClient.post<Hpg>(base(uidProtocolo), data, { signal });
    return response.data;
  },

  async listByProtocolo(uidProtocolo: string, signal?: AbortSignal): Promise<Hpg[]> {
    const response = await apiClient.get<Hpg[]>(base(uidProtocolo), { signal });
    return response.data;
  },

  async getById(uidProtocolo: string, uidAnalisis: string, signal?: AbortSignal): Promise<Hpg> {
    const response = await apiClient.get<Hpg>(`${base(uidProtocolo)}/${uidAnalisis}`, { signal });
    return response.data;
  },

  async update(
    uidProtocolo: string,
    uidAnalisis: string,
    data: HpgUpdate,
    signal?: AbortSignal
  ): Promise<Hpg> {
    const response = await apiClient.patch<Hpg>(
      `${base(uidProtocolo)}/${uidAnalisis}`,
      data,
      { signal }
    );
    return response.data;
  },

  async remove(uidProtocolo: string, uidAnalisis: string, cascade?: boolean, signal?: AbortSignal): Promise<void> {
    await apiClient.delete(`${base(uidProtocolo)}/${uidAnalisis}`, {
      signal,
      params: cascade ? { cascade: true } : undefined,
    });
  },
};
